import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20skincare%20flat%20lay%20with%20rose%20quartz%20facial%20roller%20glass%20serum%20bottles%20white%20orchid%20flowers%20on%20cream%20marble%20surface%20soft%20morning%20sunlight%20through%20sheer%20curtain%20warm%20neutral%20tones%20luxury%20beauty%20editorial%20photography%20clean%20composition&width=1600&height=900&seq=hero-skincare-01&orientation=landscape"
          alt="少妇护肤美容指南 - 精致护肤生活"
          className="w-full h-full object-cover object-center"
          title="少妇护肤美容指南 - 专为少妇定制的肌肤管理方案"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-white mb-5 leading-tight animate-fade-in-up">
          专为少妇定制的
          <br />
          肌肤管理方案
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in-up">
          深入理解少妇肌肤的独特需求，提供科学、温和、高效的护肤美容指南。
          从抗衰保湿到产后修复，从身材管理到日常护理，陪伴每一位少妇重拾自信光彩。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up">
          <Link
            to="/category/anti-aging"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3.5 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm cursor-pointer shadow-lg shadow-primary-500/25"
          >
            探索护肤指南
          </Link>
          <Link
            to="/about"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap text-sm cursor-pointer border border-white/30"
          >
            了解我们
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}